import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import './App.css';
import { AuthProvider } from './AuthContext';
import AuthContext from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import Login from "./components/Login";
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Dashboard from './pages/Dashboard';
import Billing from "./pages/Billing";
import Product from "./pages/Product";
import Addproduct from "./pages/Addproduct";
import Customer from './pages/Customer';
import GstProduct from './pages/GstProduct';
import Gstbilling from './pages/Gstbilling';
import Settings from './pages/Settings';
import Companysettings from './pages/Companysettings';
import Employee from './pages/Employee';
import Addemployee from './pages/Addemployee';
import Lead from './pages/Lead';
import Addleads from './pages/Addleads';
import Countries from './pages/Countries';
import States from './pages/States';
import City from './pages/City';
import Leaddetails from './pages/Leaddetails';
import Account from './pages/Account';
import Accountdetails from './pages/Accountdetails';
import Addaccount from './pages/Addaccount';
import Contact from './pages/Contact';
import Contactdetails from './pages/Contactdetails';
import Addcontact from './pages/Addcontact';
import User from './pages/User';
import Permission from './pages/Permission';
import Chat from './pages/ChatModern';
import Templates from './pages/Templates';
import Broadcast from './pages/Broadcast';
import WaContacts from './pages/Wacontacts';
import BroadcastReport from './pages/Broadcastreport';
import Quotation      from './pages/Quotation';
import DocumentsList  from './pages/DocumentsList';
import SalesDashboard from './pages/SalesDashboard';

function AppContent() {
  const { isAuthenticated } = React.useContext(AuthContext);
  const location = useLocation();

  // Check if the current path is "/login"
  const isLoginPage = location.pathname === '/login';

  // Define protected routes as an array of objects to map over
  const protectedRoutes = [

    { path: '/dashboard', element: <Dashboard /> },
    { path: '/billing', element: <Billing /> },
    { path: '/product', element: <Product /> },
    { path: '/customer', element: <Customer /> },
    { path: '/gstproduct', element: <GstProduct /> },
    { path: '/gstbilling', element: <Gstbilling /> },
    { path: '/settings', element: <Settings /> },
    { path: '/company-settings', element: <Companysettings /> },
    { path: '/employee', element: <Employee /> },
    { path: '/add-employee', element: <Addemployee /> },
    { path: '/lead', element: <Lead /> },
    { path: '/add-lead', element: <Addleads /> },
    { path: '/edit-lead/:id', element: <Addleads /> },
    { path: '/lead-details/:id', element: <Leaddetails /> },
    { path: '/countries', element: <Countries /> },
    { path: '/states', element: <States /> },
    { path: '/cities', element: <City /> },
    { path: '/account', element: <Account /> },
    { path: '/account-details/:id', element: <Accountdetails /> },
    { path: '/Add-account', element: <Addaccount /> },
    { path: '/contact', element: <Contact /> },
    { path: '/contact-details/:id', element: <Contactdetails /> },
    { path: '/add-contact', element: <Addcontact /> },
    { path: '/user', element: <User /> },
    { path: '/permissions/:userId', element: <Permission /> },
    { path: '/chat', element: <Chat /> },
    { path: '/templates', element: <Templates /> },
    { path: '/broadcast', element: <Broadcast /> },
    { path: '/wa-contacts', element: <WaContacts /> },
    {path: '/broadcast-report', element: <BroadcastReport /> },
    { path: '/quotation',        element: <Quotation /> },
    { path: '/documents',        element: <DocumentsList /> },
    { path: '/sales-dashboard', element: <SalesDashboard /> },

  ];
  return (
    <div className="App">
      {!isLoginPage ? (
        <div className="main-wrapper">
          {isAuthenticated && <Header />}
          {isAuthenticated && <Sidebar />}
          <div>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
                }
              />

              {/* Protected Routes */}
              {protectedRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={<ProtectedRoute>{route.element}</ProtectedRoute>}
                />
              ))}
            </Routes>
          </div>
        </div>
      ) : (
        // Render only the login page without the wrapper and main layout
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      )}
    </div>
  );
}

const App = () => (
  <AuthProvider>
    <Router>
      <AppContent />
    </Router>
  </AuthProvider>
);

export default App;
